import { atom } from "recoil"
import { IUtag } from "../../models/IUtag"
import { Key } from "../EnumKey"

const utagObjectAtom = atom({
  key: Key.UTAG,
  default: {} as IUtag
})

export default utagObjectAtom